import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/payjet_logo_neu.png'
import _imports_1 from '@/assets/Rectangle_6833.png'


const _hoisted_1 = { class: "flex min-h-full bg-white rounded rounded-2xl rounded-5" }
const _hoisted_2 = {
  class: "flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24",
  style: {"width":"calc(50vw - 12px)"}
}
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = { class: "mt-6 flex items-center" }
const _hoisted_5 = {
  href: "/login",
  title: "Zurück zum Login"
}
const _hoisted_6 = { class: "mt-8" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "space-y-6" }
const _hoisted_9 = { class: "space-y-1" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = {
  key: 1,
  class: "space-y-1"
}
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = {
  key: 2,
  class: "bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_16 = { class: "block sm:inline" }
const _hoisted_17 = {
  key: 3,
  class: "bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_18 = { class: "block sm:inline" }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            alt: "Workflow",
            class: "h-12 w-auto",
            src: _imports_0
          }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", _hoisted_5, [
              _createVNode(_component_ArrowLeftIcon, {
                "aria-hidden": "true",
                class: "h-7 w-7 mr-3",
                style: {"color":"rgb(88, 80, 236)"}
              })
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-3xl font-bold tracking-tight text-gray-900" }, "Passwort zurücksetzen", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "email"
                }, "Email Adresse", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    autocomplete: "email",
                    class: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                    name: "email",
                    required: "",
                    type: "email"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              (_ctx.token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", {
                      class: "block text-sm font-medium text-gray-700",
                      for: "password"
                    }, "Wähle dein neues Passwort", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                        autocomplete: "current-password",
                        class: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                        name: "password",
                        required: "",
                        type: "password"
                      }, null, 512), [
                        [_vModelText, _ctx.password]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", {
                      class: "block text-sm font-medium text-gray-700",
                      for: "passwordVerify"
                    }, "Passwort wiederholen", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        id: "passwordVerify",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordVerify) = $event)),
                        autocomplete: "current-password",
                        class: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                        name: "passwordVerify",
                        required: "",
                        type: "password"
                      }, null, 512), [
                        [_vModelText, _ctx.passwordVerify]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.passwordresetmailmessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.passwordresetmailmessage), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.passwordresetmessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.passwordresetmessage), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doPasswordResetMail && _ctx.doPasswordResetMail(...args)))
                    }, " Passwort zurücksetzen ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.token)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doResetPassword && _ctx.doResetPassword(...args)))
                    }, " Passwort zurücksetzen ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "relative hidden w-0 flex-1 lg:block" }, [
      _createElementVNode("img", {
        alt: "",
        class: "rounded-r rounded-r-3 absolute inset-0 h-full w-full object-cover",
        src: _imports_1
      })
    ], -1))
  ]))
}